let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("FOgP0"), load("3IEky"), load("6XNSn")]).then(() => parcelRequire('2SLpl'));